/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const organizations = (state) => {
  return state.organizations
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getOrganizationById = (state) => (id) => {
  return state.organizations.find(org => org.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  organizations,
  total,
  offset,
  max,
  getOrganizationById,
  sort,
  order
}
